<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3" *ngIf="!isGestao">Favorecidos</span>
        <span class="label-title ml-2 mr-3" *ngIf="isGestao">Gestão de Créditos</span>
        <ng-container *ngIf="!isGestao" class="">
            <button [hidden]="!permitirVincularQRemLote" class="action-button ml-2 my-1" (click)="RedirectToVincularQRLote()">Vincular QRCodes em lote</button>
            <button [hidden]="!permitirAdicionarColaboradorEmLotes" class="action-button ml-2 my-1" (click)="createLote()">Adicionar Favorecidos em lote</button>
            <button class="action-button ml-2 my-1" (click)="createViaArquivo()">Criar Favorecidos via arquivo</button>
            <button class="action-button ml-2 my-1" (click)="create()">Novo Favorecido</button>
        </ng-container>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">

            <div class="row">
                <div class="col-md-12 text-right" *ngIf="!isMobile">
                    <ul class="options-cadastro">
                        <li *ngIf="false">
                            <div (click)="
                                    selectAllToDelete((selectAll = !selectAll))
                                " [ngClass]="{ active: deleteCount > 0 }" class="list-select ml-2 my-1">
                                <button class="list-select" type="button">
                                    <span>Selecionar tudo</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                                my-1">
                                <button class="list-select"  type="button">
                                    <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                    <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-select-search-input ml-2 my-1">
                                <input class="w-100 ng-untouched ng-pristine
                                    ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChangedGateway(1)" autocomplete="off"/>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="col-md-12" *ngIf="isMobile">
                    <div class="list-select-search-input list-select-search-input-mobile ml-2 my-1">
                        <input class="w-100 ng-untouched ng-pristine ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChangedGateway(1)" autocomplete="off"/>
                    </div>
                    <button class="btn-search" (click)="pageChangedGateway(1)">
                        Buscar
                    </button>
                </div>

                <div *ngIf="false" class="list-delete mr-4 my-1" (click)="showDeleteAll(deleteallmodal)" [ngClass]="{ active: deleteCount > 0 }">
                    <img [src]="
                            deleteCount > 0
                                ? '/assets/icons/garbage-purple.png'
                                : '/assets/icons/garbage-grey.png'
                        " width="auto" height="20px" />
                    <span class="mx-2">Excluir</span>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 component-subtitle">
                    <p class="component-subtitle color text-right"> {{totalItems}} favorecidos
                    </p>
                </div>
            </div> -->

            <div class="table-overflow">
                <ng-container *ngFor="
                        let item of collaboratorsList
                            | paginate
                                : {
                                      itemsPerPage: showItem,
                                      currentPage: currentPage,
                                      totalItems: totalItems
                                  }
                    ">
                    <div *ngIf="isMobile">
                        <div ngbDropdown class="d-inline-block menu-option button-mobile" placement="left">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                <img src="assets/icons/menu.png" />
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">

                                    <ng-container *ngIf="isGestao">
                                        <div ngbDropdownItem (click)="NavigateToResgateBeneficio(item)">
                                            <img src="assets/icons/user-purple.png" class="mr-2" />Resgate de Créditos
                                        </div>

                                        <div ngbDropdownItem (click)="NavigateToTransfereBeneficio(item)">
                                            <img src="assets/icons/user-purple.png" class="mr-2" />Transferência de Créditos
                                        </div>

                                        <div ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                            <img src="assets/icons/contrato.png" class="mr-2" />Saldos do Favorecido
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="!isGestao">
                                        <div *ngIf="permitirVincularQRCode && !item.hasCard" ngbDropdownItem (click)="ShowModalQRCode(modalQRCode,item)">
                                            <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Carregar Cartão QR Code
                                        </div>

                                        <div *ngIf="permitirVincularQRCode && !item.hasCard" ngbDropdownItem (click)="ShowQRCodeModal(QRCodeModal, item)">
                                            <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Vincular Cartão QR Code
                                        </div>

                                        <div *ngIf="item.situationID === 1 && !item.suspended" ngbDropdownItem (click)="ShowModalCarregarCartao(modalCarregarCartao,item)">
                                            <img src="assets/icons/shopp-car-purple.png" class="mr-2" style="width:15px" />Carregar crédito
                                        </div>

                                        <div ngbDropdownItem (click)="edit(item)">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />Editar Favorecido
                                        </div>

                                        <div ngbDropdownItem (click)="RedirectToCard(item.collaboratorID,item.name)">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />Ver produtos concedidos
                                        </div>

                                        <div *ngIf="mostrarDetalhes" ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                            <img src="assets/icons/contrato.png" class="mr-2" />Ver Detalhes
                                        </div>
                                    </ng-container>



                                    <div *ngIf="permitirVincularQRCode && item.hasCard" ngbDropdownItem (click)="
                                            ShowModalAlterarSenha(
                                                modalAlterarSenha,
                                                item
                                            )
                                        ">
                                        <img src="assets/icons/user-purple.png" class="mr-2" style="width:15px" /> Alterar Senha
                                    </div>

                                    <div *ngIf="permitirDesativarColaborador && item.situationID === 1" ngbDropdownItem (click)="showDesativar(desativarmodal, item)">
                                        <img src="assets/icons/remove-user.png" style="width:16px" class="mr-2" />Desativar Favorecido
                                    </div>

                                    <div *ngIf="permitirDesativarColaborador && (item.situationID === 2 || item.situationID === 3)" ngbDropdownItem (click)="showAtivar(ativarmodal, item)">
                                        <img src="assets/icons/add-user.png" style="width:15px" class="mr-2" />Ativar Favorecido
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="isMobile">
                        <tbody class="list-table-row">
                            <tr *ngIf="
                                    permitirVincularQRCode &&
                                    item.statusApp === 'Pendente'
                                ">
                                <td style="border: transparent;">
                                    <div (click)="
                                            ShowModalQRCode(modalQRCode, item)
                                        " class="text-center">
                                        <img src="assets/icons/barcode.png" />
                                        <p>Vincular Cartão QR Code</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="td-mobile">Nome:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.name }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">CPF:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    "><span *ngIf="item.document || item.document != null">{{ item.document | cpf }}</span>
                                    <span *ngIf="!item.document || item.document == null"></span>

                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">{{ labelMatricula }}:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.register }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">Unidade:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.unit">{{
                                        item.unit
                                    }}</span>
                                    <span *ngIf="!item.unit">Nenhum</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="!isMobile">
                        <thead>
                            <tr>
                                <!-- <th></th> -->
                                <th *ngIf="mostrarColunaAplicativo" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy(
                                            'collaboratorID',
                                            sortOrder
                                        )
                                    ">
                                    Apto?
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('name', sortOrder)
                                    ">
                                    Nome
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('document', sortOrder)
                                    ">
                                    CPF
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('register', sortOrder)
                                    ">
                                    {{ labelMatricula }}
                                </th>
                                <th>
                                    Tipo
                                </th>
                                <th *ngIf="mostrarColunaCentroCusto" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('costCenter', sortOrder)
                                    ">
                                    {{ labelCentroCusto }}
                                </th>
                                <th *ngIf="mostrarColunaDepartamento" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('departament', sortOrder)
                                    ">
                                    {{ labelDepartamento }}
                                </th>
                                <th *ngIf="mostrarColunaUnidade" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('unit', sortOrder)
                                    ">
                                    {{ labelUnidade }}
                                </th>
                                <!-- <th *ngIf="mostrarColunaAplicativo" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy(
                                            'collaboratorID',
                                            sortOrder
                                        )
                                    ">
                                    Tem Cartão?
                                </th> -->
                                <th *ngIf="mostrarColunaStatus" (click)="
                                    sortOrder = !sortOrder;
                                    orderBy('situation', sortOrder)
                                    ">
                                    {{ labelSituacao }}
                                </th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor="
                                let item of collaboratorsList
                                    | paginate
                                        : {
                                            itemsPerPage: showItem,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                        }
                            ">
                                <!-- <td class="clickable" (click)="item.toDelete=
                                    !item.toDelete; updateDeleteCount();">
                                    <span class="mx-2">
                                        <input [attr.id]="item.colaboradorId" type="checkbox" class="radio-checkbox"
                                            [(ngModel)]="item.toDelete" (click)="item.toDelete=
                                            !item.toDelete;
                                            updateDeleteCount();" />
                                        <label [attr.for]="item.colaboradorId" class="radio-label"></label>
                                    </span>
                                </td> -->
                                <td *ngIf="mostrarColunaAplicativo" class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <div class="img-status">
                                        <span *ngIf="item.accountDisabled && !item.blocked" data-bs-toggle="tooltip" title="Conta desativada">
                                            <img class="img-status" src="./assets/icons/status-yellow.png" />
                                        </span>
                                        <span *ngIf="(!item.hasCard && item.hasApp) && !item.blocked && !item.accountDisabled" data-bs-toggle="tooltip" title="Já possui aplicativo">
                                            <img class="img-status" src="./assets/icons/status-green.png" />
                                        </span>
                                        <span *ngIf="(item.hasCard && !item.hasApp) && !item.blocked && !item.accountDisabled" data-bs-toggle="tooltip" title="Já possui cartão">
                                            <img class="img-status" src="./assets/icons/status-green.png" />
                                        </span>
                                        <span *ngIf="(item.hasCard && item.hasApp) && !item.blocked && !item.accountDisabled" data-bs-toggle="tooltip" title="Já possui aplicativo e cartão">
                                            <img class="img-status" src="./assets/icons/status-green.png" />
                                        </span>
                                        <span *ngIf="!item.hasApp && !item.hasCard && !item.blocked && !item.accountDisabled">
                                            <img class="img-status" src="./assets/icons/status-yellow.png" data-bs-toggle="tooltip" title="Não possui aplicativo ou cartão"/>
                                        </span>
                                        <span *ngIf="item.blocked" data-bs-toggle="tooltip" title="{{item.reason}}">
                                            <img class="img-status" src="./assets/icons/lock.png" style="width: 26px;"/>
                                        </span>
                                    </div>
                                </td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.name }}
                                </td>
                                <td class="clickable text-nowrap" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.document || item.document != null">{{ item.document | cpf }}</span>
                                    <span *ngIf="!item.document || item.document == null"></span>
                                </td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.register }}
                                </td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span>{{ item.collaboratorType }}</span>
                                </td>
                                <td *ngIf="mostrarColunaCentroCusto" class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.costCenter">{{
                                        item.costCenter
                                    }}</span>
                                    <span *ngIf="!item.costCenter">Nenhum</span>
                                </td>
                                <td *ngIf="mostrarColunaDepartamento" class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.departament">{{
                                        item.departament
                                    }}</span>
                                    <span *ngIf="!item.departament">Nenhum</span>
                                </td>
                                <td *ngIf="mostrarColunaUnidade" class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.unit">{{
                                        item.unit
                                    }}</span>
                                    <span *ngIf="!item.unit">Nenhum</span>
                                </td>
                                <td *ngIf="mostrarColunaStatus" class="clickable" (click)="
                                    item.toDelete = !item.toDelete;
                                    updateDeleteCount()
                                ">
                                    <span *ngIf="!item.suspended">{{item.situation}}</span> 
                                    <span *ngIf="item.suspended">Suspenso</span> 
                                </td>
                                <td *ngIf="mostrarColunaAplicativo" class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <div class="img-status">
                                        <span *ngIf="item.hasApp" >
                                            <img src="./assets/icons/smartphone.png" />
                                        </span>
                                        <span *ngIf="item.hasCard" data-bs-toggle="tooltip" (click)="copyCode(item.qrCode)" title="{{item.qrCode | uppercase}}">
                                            <img src="./assets/icons/barcode.png"/>
                                        </span>
                                        <span *ngIf="item.collaboratorCardId != null && !item.collaboratorCardDefinitiveBlock">
                                            <img src="./assets/icons/creditCard.png" height="24px" width="36px"/>
                                        </span>
                                        <span class="ml-1" *ngIf="item.conductor" data-bs-toggle="tooltip" data-bs-placement="right" title="Condutor">
                                            <img src="./assets/icons/volante.svg" style="height: 32px;"/>
                                        </span>
                                    </div>
                                </td>
                                <!-- <td *ngIf="mostrarColunaAplicativo">
                                    <span *ngIf="item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-green.png" />
                                    </span>
                                    <span *ngIf="!item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-yellow.png" />
                                    </span>
                                </td> -->
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                        menu-option custom-context-menu-container" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">

                                                <div ngbDropdownItem (click)="lastCredits(item,modalLastCredits)">
                                                    <img src="assets/icons/contrato.png" class="mr-2" />Histórico de Créditos
                                                </div>

                                                <ng-container *ngIf="isGestao">
                                                    <div ngbDropdownItem (click)="showModalExtractFavored(modalExtractFavored,item)">
                                                        <img src="assets/icons/comprovante.png" class="mr-2" />Extrato do Favorecido
                                                    </div>

                                                    <div ngbDropdownItem (click)="NavigateToResgateBeneficio(item)">
                                                        <img src="assets/icons/user-purple.png" class="mr-2" />Resgate de Créditos
                                                    </div>

                                                    <div ngbDropdownItem (click)="NavigateToTransfereBeneficio(item)">
                                                        <img src="assets/icons/transfere.png" class="mr-2" />Transferência de Créditos
                                                    </div>

                                                    <div ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                                        <img src="assets/icons/contrato.png" class="mr-2" />Saldos do Favorecido
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="!isGestao">
                                                    <div *ngIf="permitirVincularQRCode && !item.hasCard" ngbDropdownItem (click)="ShowModalQRCode(modalQRCode,item)">
                                                        <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Carregar Cartão QR Code
                                                    </div>

                                                    <div *ngIf="permitirVincularQRCode && !item.hasCard" ngbDropdownItem (click)="ShowQRCodeModal(QRCodeModal,item)">
                                                        <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Vincular Cartão QR Code
                                                    </div>
                                                    <div ngbDropdown class="submenu-option custom-context-submenu-container p-0 w-100" placement="left" [ngStyle]="{ display: (permitirCartaoFisico && (item.collaboratorTypeId == 1 || item.collaboratorTypeId == 2)) ? 'block' : 'none' }" >
                                                        <div class="dropdown-button" id="dropdownMenu" *ngIf="permitirCartaoFisico && (item.collaboratorTypeId == 1 || item.collaboratorTypeId == 2)"
                                                        ngbDropdownToggle >
                                                            <img src="assets/icons/creditCard.png" class="mr-2" style="width:15px"/>
                                                            Cartão Bankei
                                                            <span style="margin-left: 50px; color: #111224; font-weight: bold;">&#10093;</span>
                                                        </div>
                                                        <div aria-labelledby="dropdownMenu" class="p-0 m-0 custom-context-submenu div-submenu" ngbDropdownMenu>
                                                            <!-- Sub level -->
                                                            <section class="custom-context-submenu">
                                                                <div class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                    (click)="VincularCartao(item)" class="dropdown-item">
                                                                    <img src="assets/icons/linkCard.png" class="mr-2" style="width: 18px;"/>Vincular novo cartão
                                                                </div>                                                                
                                                                <div *ngIf="item.collaboratorCardId != null" class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                    (click)="ShowModalVerCartao(modalVerCartao,item)" class="dropdown-item">
                                                                    <img src="assets/icons/seeCard-bold.png" class="mr-2" style="width: 18px;"/>Ver Cartão
                                                                </div>
                                                                <!-- <div class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                    (click)="ShowModalNovoSMS(modalNovoSMS,item)" class="dropdown-item">
                                                                    <img src="assets/icons/sendSms-b.png" class="mr-2" style="width: 18px;"/>Reenviar SMS com Senha
                                                                </div> -->
                                                                <div *ngIf="item.collaboratorCardId != null" class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                    (click)="ShowModalTrocarSenhaCartao(modalTrocarSenhaCartao,item)" class="dropdown-item">
                                                                    <img src="assets/icons/resetPassword.png" class="mr-2" style="width: 18px;"/>Trocar Senha
                                                                </div>
                                                                <ng-container *ngIf="temContaDespesas">
                                                                    <hr *ngIf="item.cardholder || item.cardholderCardId != null">
                                                                    <div class="btn item" id="dropdownSubMenu" ngbDropdownItem *ngIf="item.cardholder"
                                                                        (click)="VincularCartaoPortador(item)" class="dropdown-item">
                                                                        <img src="assets/icons/linkCard.png" class="mr-2" style="width: 18px;"/>Vincular novo cartão portador
                                                                    </div>
                                                                    <!-- <div *ngIf="item.collaboratorCardId != null" class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                        (click)="ShowModalVerCartaoPortador(modalVerCartaoPortador,item)" class="dropdown-item">
                                                                        <img src="assets/icons/seeCard-bold.png" class="mr-2" style="width: 18px;"/>Ver Cartão portador
                                                                    </div> -->
                                                                    <div *ngIf="item.cardholderCardId != null" class="btn item" id="dropdownSubMenu" ngbDropdownItem
                                                                        (click)="ShowModalTrocarSenhaCartaoPortador(modalTrocarSenhaCartaoPortador,item)" class="dropdown-item">
                                                                        <img src="assets/icons/resetPassword.png" class="mr-2" style="width: 18px;"/>Trocar Senha portador
                                                                    </div>
                                                                </ng-container>
                                                            </section>
                                                        </div>
                                                    </div>


                                                    <div *ngIf="item.situationID === 1 && !item.suspended" ngbDropdownItem (click)="ShowModalCarregarCartao(modalCarregarCartao,item)">
                                                        <img src="assets/icons/shopp-car-purple.png" class="mr-2" style="width:15px" />Carregar crédito
                                                    </div>

                                                    <div ngbDropdownItem (click)="edit(item)">
                                                        <img src="assets/icons/pencil-purple.png" class="mr-2" />Editar Favorecido
                                                    </div>

                                                    <div ngbDropdownItem (click)="RedirectToCard(item.collaboratorID,item.name)">
                                                        <img src="assets/icons/pencil-purple.png" class="mr-2" />Ver produtos concedidos
                                                    </div>

                                                    <div *ngIf="mostrarDetalhes" ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                                        <img src="assets/icons/contrato.png" class="mr-2" />Ver Detalhes
                                                    </div>

                                                    <div *ngIf="permitirDesativarColaborador && item.situationID === 1" ngbDropdownItem (click)="showDesativar(desativarmodal, item)">
                                                        <img src="assets/icons/remove-user.png" style="width:16px" class="mr-2" />Desativar Favorecido
                                                    </div>

                                                    <div *ngIf="permitirDesativarColaborador && (item.situationID === 2 || item.situationID === 3)" ngbDropdownItem (click)="showAtivar(ativarmodal, item)">
                                                        <img src="assets/icons/add-user.png" style="width:15px" class="mr-2" />Ativar Favorecido
                                                    </div>

                                                    <div *ngIf="false" ngbDropdownItem (click)="showDesativar(showSuspender, item)">
                                                        <img src="assets/icons/remove-user.png" style="width:16px" class="mr-2" />Suspender Favorecido
                                                    </div>

                                                    <div *ngIf="item.conductor" ngbDropdownItem (click)="showResetarSenhaCondutor(showConductor, item.conductorGuid)">
                                                        <img src="assets/icons/resetPassword.png" class="mr-2" style="width: 18px;"/>Resetar senha do Condutor
                                                    </div>
                                                </ng-container>

                                                <div *ngIf="permitirVincularQRCode && item.hasCard" ngbDropdownItem (click)="ShowModalAlterarSenha(modalAlterarSenha,item)">
                                                    <img src="assets/icons/user-purple.png" class="mr-2" style="width:15px" /> Alterar Senha
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="collaboratorsList.length === 0" class="text-center">
                        <h6>
                            Nenhum favorecido carregado. Faça uma busca para retornar a lista de favorecidos
                        </h6>
                    </div>

                    <div class="page-custom mt-2" *ngIf="!isMobile">
                        <pagination-controls (pageChange)="pageChangedGateway($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <!-- <div class="col-lg-3 col-md-6 col-sm-12 my-4">
        <div class="custom-filter-input-container">
            <input id="colaboradorId" #colaboradorId class="custom-filter-input" type="text" value="{{ filtroCodigo }}" />
            <label class="custom-filter-label" for="colaboradorId">Código:</label>
        </div>
    </div> -->
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Nome</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="name">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>CPF</mat-label>
                <input [formControl]="cpfCtrl" matInput type="text" [textMask]="{mask: cpfMask}" [(ngModel)]="filtroCPF" id="cpf">
                <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>{{ labelMatricula }}</mat-label>
                <input [formControl]="registerCtrl" matInput type="text" [(ngModel)]="filtroMatricula" id="register">
                <button mat-button *ngIf="filtroMatricula" matSuffix mat-icon-button aria-label="Clear" (click)="filtroMatricula=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>{{ labelCentroCusto }}</mat-label>
                    <mat-select [formControl]="costCenterCtrl" multiple>
                        <mat-option *ngFor="let item of filtroCentroCustoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>{{ labelUnidade }}</mat-label>
                    <mat-select [formControl]="unitCtrl" multiple>
                        <mat-option *ngFor="let item of filtroUnidadeDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <mat-form-field>
                    <mat-label>{{ labelDepartamento }}</mat-label>
                    <mat-select [formControl]="departmentCtrl" multiple>
                        <mat-option *ngFor="let item of filtroDepartamentoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Apto?</mat-label>
                    <mat-select [formControl]="appCtrl" placeholder="Selecione...">
                        <mat-option>Nenhum</mat-option>
                        <mat-option value="">Indiferente</mat-option>
                        <mat-option value="true">Ativo</mat-option>
                        <mat-option value="false">Pendente</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>{{labelSituacao}}</mat-label>
                    <mat-select [formControl]="situationCtrl" placeholder="Selecione...">
                        <mat-option value="">Nenhum</mat-option>
                        <mat-option value="1">Ativo</mat-option>
                        <mat-option value="3">Desligado</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <mat-form-field>
                    <mat-label>{{ labelProdutos }}</mat-label>
                    <mat-select [formControl]="productCtrl" multiple>
                        <mat-option *ngFor="let item of filtroProdutosDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <mat-form-field>
                    <mat-label>Tipo</mat-label>
                    <mat-select [formControl]="typeCtrl">
                        <mat-option *ngFor="let item of collaboratorType" [value]="item.collaboratorTypeId">{{item.collaboratorType}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

<!--Modal Alterar Senha-->
<ng-template #modalAlterarSenha let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h2 class="modal-title clean-modal-title">Alteração de senha do cartão</h2>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 clean-modal-content">
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <div class="form-group">
                    <label for="password" class="clean-modal-section-title ">Escolha uma senha</label>
                    <input class="input-border-botton form-control" [ngClass]="{'is-invalid':messageSenha}" type="password" value="" onlyNumber maxlength="6" #inResetSenha autocomplete="off"/>
                </div>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <div class="form-group">
                    <label for="confirmpassword" class="clean-modal-section-title ">Confirme a senha</label>
                    <input class="input-border-botton form-control" [ngClass]="{'is-invalid':messageSenha}" type="password" value="" onlyNumber maxlength="6" #inResetSenhaConfirmacao autocomplete="off"/>
                </div>
                <span  class="invalid-feedback" *ngIf="messageSenha">
                    {{ messageSenha }}
                </span>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just mr-2" type="button" (click)="
                AlterarSenha(
                    inResetSenha.value,
                    inResetSenhaConfirmacao.value)">
            Confirmar
        </button>
    </div>
</ng-template>

<!--Modal Alterar Senha-->
<ng-template #modalAlterarSenhaW let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <div [ngStyle]="{ display: step == 0 ? 'block' : 'none' }">
                    <h1>Vamos alterar a senha do cidadão</h1>

                    <p class="p-just">Escolha uma senha</p>
                    <input class="w-75 d-inline-block" type="password" value="" onlyNumber maxlength="4" #inResetSenha autocomplete="off"/>

                    <p class="p-just">Confirme a senha</p>
                    <input class="w-75 d-inline-block" type="password" value="" onlyNumber maxlength="4" #inResetSenhaConfirmacao autocomplete="off"/>

                    <span class="legend" *ngIf="inSenhaInvalid">
                        <img src="./assets/icons/alerta-vermelho-transparent.svg" >
                        {{ messageSenha }}
                    </span>
                </div>

                <ng-container *ngIf="step == 1">
                    {{ messageStep }}
                </ng-container>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="
                        AlterarSenha(
                            inResetSenha.value,
                            inResetSenhaConfirmacao.value
                        )
                    " *ngIf="step == 0">
                    Confirmar
                </button>

                <button class="custom-modal-button" type="button" (click)="modal.dismiss('Close click')" *ngIf="step == 1">
                    Ok
                </button>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')" *ngIf="step != 1">
                    Cancelar
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal do Beneficios-->
<ng-template #benefitsModal let-modal>
    <ng-container *ngIf="showBenefits">
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="modal-title clean-modal-title">
                    Saldos do favorecido
                </h5>
                <p class="clean-modal-subtitle">
                    Visualize os saldos atuais e os lançamentos futuros do favorecido.
                </p>
            </div>
        </div>
        <div class="col-12 clean-modal-content">
            <p class="clean-modal-section-title">Saldos:</p>
            <ng-container *ngIf="
                            CollaboratorDetailsModel.currentProduct.length > 0
                        ">
                <div class="row col-md-12">
                    <div class="card col-md-4 clean-card-container" *ngFor="let currentProduct of CollaboratorDetailsModel.currentProduct
                            ">
                        <div class="card-body clean-card-content">
                            <p class="card-title mb-2">{{ currentProduct.nomeBeneficio }}</p>
                            <!-- <p class="p-list-account text-muted">{{ currentProduct.numeroCartao }}</p> -->
                            <p class="card-text">{{ currentProduct.valorBeneficio
                                <=0 ? "R$ 0,00" : (currentProduct.valorBeneficio | currency: "BRL":true) }}</p>
                                    <span class="red" *ngIf="currentProduct.mensagemErro">
                                        ({{currentProduct.mensagemErro}})</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="
                            CollaboratorDetailsModel.currentProduct.length <= 0
                        ">
                <p class="p-list-account">Não existem lançamentos</p>
            </ng-container>

            <p class="clean-modal-section-title">Lançamentos futuros:</p>
            <ng-container *ngIf="
                            CollaboratorDetailsModel.futureProduct.length > 0
                        ">
                <p class="p-list-account" *ngFor="
                                let futureProduct of CollaboratorDetailsModel.futureProduct
                            ">
                    {{ futureProduct.nomeBeneficio }}: {{ futureProduct.valorBeneficio
                    <=0 ? "R$ 0,00" : (futureProduct.valorBeneficio | currency: "BRL":true) }} <span class="red" *ngIf="futureProduct.mensagemErro">
                        ({{futureProduct.mensagemErro}})</span>
                        <span *ngIf="!futureProduct.mensagemErro">
                                -
                                {{
                                futureProduct.dataLiberacaoBeneficio
                                    | date: "dd/MM/yy HH:mm"
                                }}
                            </span>
                </p>
            </ng-container>

            <ng-container *ngIf="
                            CollaboratorDetailsModel.futureProduct.length <= 0
                        ">
                <p class="p-list-account">
                    Não existem lançamentos futuros
                </p>
            </ng-container>
        </div>
        <div class="col-12 clean-modal-footer">
            <button class="clean-modal-button-text button-cancel" type="button" (click)="modal.dismiss('Close click')">
                        FECHAR
                    </button>
        </div>
    </ng-container>

    <ng-container *ngIf="!showBenefits">
        <div class="col-12 clean-modal-title my-5 text-center">
            {{ messageStatus }}
        </div>
        <div class="col-12 text-center my-2">
            <button class="clean-modal-button" type="button" (click)="modal.dismiss('Close click')">
                        Ok
                    </button>
        </div>
    </ng-container>
</ng-template>

<!--Modal do QR Code-->
<ng-template #QRCodeModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Cartão de incentivos
            </h5>
            <p class="clean-modal-subtitle">
                Vamos vincular o cartão ao favorecido
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="row ml-3 mb-2">
            <img src="./assets/icons/ico_cartao_qr.svg" height="100px" alt="Cartão QR Code">
        </div>
        <div class="clean-modal-text">
            <form [formGroup]="associateCardForm" *ngIf='!messageStatus'>
                <div class="form-group col-lg-6 col-md-12 col-sm-12 float-left">
                    <div class="form-group">
                        <label for="code" class="clean-modal-section-title">Digite o código impresso no cartão</label>
                        <input type="text" class="input-border-botton form-control" [ngClass]="{'is-invalid':inCodigoInvalid}" formControlName="code" autocomplete="off"/>
                    </div>

                    <div class="form-group">
                        <label for="confirmCode" class="clean-modal-section-title">Confirme o código</label>
                        <input type="text" class="input-border-botton form-control" [ngClass]="{'is-invalid':inCodigoInvalid}" formControlName="confirmCode" autocomplete="off"/>
                    </div>

                    <span class="invalid-feedback" *ngIf="inCodigoInvalid">
                        {{ messageCodigo }}
                    </span>
                </div>

                <div class="form-group col-lg-6 col-md-12 col-sm-12 float-left">
                    <div class="form-group">
                        <label for="password" class="clean-modal-section-title" *ngIf="!usarSenhaExistente">Digite uma senha de 6 números</label>
                        <label for="password" class="clean-modal-section-title" *ngIf="usarSenhaExistente">Digite sua senha</label>
                        <input type="password" onlyNumber class="input-border-botton form-control" [ngClass]="{'is-invalid':inSenhaInvalid}" maxlength="6" formControlName="password" autocomplete="off"/>
                    </div>

                    <ng-container *ngIf="!usarSenhaExistente">
                        <div class="form-group">
                            <label for="confirmpassword" class="clean-modal-section-title">Confirme a senha</label>
                            <input type="password" onlyNumber  class="input-border-botton form-control" [ngClass]="{'is-invalid':inSenhaInvalid}" maxlength="6" formControlName="confirmPassword" autocomplete="off"/>
                        </div>
                    </ng-container>

                    <div *ngIf="(associateCardForm.get('password').invalid && associateCardForm.get('password').dirty
                        || associateCardForm.get('password').touched)
                        || (associateCardForm.get('confirmPassword').invalid && associateCardForm.get('confirmPassword').dirty
                        || associateCardForm.get('confirmPassword').touched)" >

                        <span class="invalid-feedback" *ngIf="associateCardForm.get('password').hasError('required') || associateCardForm.get('confirmPassword').hasError('required')">
                            Campos de senha obrigatórios
                        </span>
                    </div>
                    <span class="invalid-feedback" *ngIf="inSenhaInvalid">
                        {{ messageSenha }}
                    </span>
                </div>
            </form>

            <p class="text-center" *ngIf='messageStatus'>
                {{ messageStatus }}
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click');associateCardForm.reset()">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" (click)="vincularQrCode()">
            Concluir
        </button>
    </div>
</ng-template>

<!--Modal do QR Code-->
<ng-template #modalQRCode let-modal>
    <ng-container *ngIf="hasBeneficios">
        <div class="col-12 my-5">
            <div [ngStyle]="{ display: step == 0 ? 'block' : 'none' }">
                <h5 class="modal-title clean-modal-title">Incentivos</h5>
                <p class="clean-modal-subtitle">Escolha um incentivo para vincular ao cartão</p>
                <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct == null">
                    <div *ngFor="let categoria of beneficioGrupo">
                        <ng-container *ngIf="categoria.beneficios.length > 0">
                            <h5 class="modal-title clean-modal-title text-left my-2" style="font-size: 20px;">{{categoria.produtoCategoriaLabelCedente}}</h5>
                            <div class="row col-md-12">
                            <div class="col-md-3 px-0" *ngFor="let item of categoria.beneficios; let i= index">
                                <div (click)="setProdutoCarga(item)">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                        <div class="card-img-top clickable">
                                            <app-svg-card [color]="item.produtoColor" [icon]="item.produtoIcon" [name]="item.produtoNome"></app-svg-card>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                        <p class="card-title ">
                                            {{item.produtoNome}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
                <!-- <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct == null">
                    <div class="row col-md-12">
                        <div class="card col-md-4 clean-card-container" *ngFor="let item of beneficios; let i= index">
                            <div cclass="card-body clean-card-content" (click)="setProdutoCarga(item)">
                                <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                    <img [src]="'./assets/icons/produtos/icon-produtos/'+ item.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="card-img-top clickable" alt="{{item.produtoNome}}"/>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                    <p class="card-title">
                                        {{item.produtoNome}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container> -->
            </div>
            <div [ngStyle]="{ display: step == 10 ? 'block' : 'none' }">
                <h5 class="modal-title clean-modal-title">Vamos vincular o cartão ao favorecido</h5>
                <div class="w-100" *ngIf="showScanner">
                    <ng-container *ngIf="hasPermission === undefined">
                        <h4>Aguardando permissão para câmera</h4>
                    </ng-container>
                    <ng-container *ngIf="hasPermission === false">
                        <h4>
                            Você negou a permissão para a câmera. Não será possível escanear o código QR.
                        </h4>
                    </ng-container>
                    <ng-container *ngIf="qrCodeDetected">
                        <h4>Código QR detectado pela câmera</h4>
                    </ng-container>
                    <zxing-scanner [class.qrcode-detected]="qrCodeDetectedVisivle" [(device)]="currentDevice" (scanSuccess)="onCodeResult($event)" [formats]="formatsEnabled" [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)" (camerasFound)="onCamerasFound($event)">
                    </zxing-scanner>
                </div>
                <div class="container">
                    <div class="row mt-3">
                        <div class="col-md-5" style="align-self: center;">
                            <img src="./assets/icons/ico_cartao_qr.svg" alt="Cartão QR Code" height="100px">
                        </div>
                        <div class="col-md-7">
                            <div class="row">
                                <div class="form-group w-75">
                                    <label for="codigoqr" class="clean-modal-section-title">Código QR</label>
                                    <input class="input-border-botton form-control" [ngClass]="{'is-invalid':inQRCodeInvalid}" type="text" [value]="qrResultString" #inQRCode autocomplete="off"/>
                                </div>
                                <span class="invalid-feedback" *ngIf="inQRCodeInvalid">
                                    Digite o código do QR Code impresso no cartão
                                </span>
                            </div>
                            <div class="row">
                                <div class="form-group w-75">
                                    <label for="valor" class="clean-modal-section-title">Valor do incentivo</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">R$</span>
                                        </div>
                                        <input [readonly]="!cedenteContrato.ehEditavel" [(ngModel)]="valorRecarga" class="input-border-botton form-control" [ngClass]="{'is-invalid':inValorInvalid}" type="number" value="{{ cedenteContrato.valorPadrao }}" min="{{ cedenteContrato.valorPadrao }}" step="{{cedenteContrato.valorIncremento}}" max="{{ cedenteContrato.valorMaximoBeneficio }}" #inValor autocomplete="off"/>
                                    </div>
                                </div>
                                <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && cedenteContrato.ehPorcentagem">
                                    A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? valorRecarga * cedenteContrato.taxaPedido / 100 : cedenteContrato.valorPadrao * cedenteContrato.taxaPedido / 100) | currency:'BRL':true}}
                                </span>
                                <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && !cedenteContrato.ehPorcentagem">
                                    A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? cedenteContrato.taxaPedido :cedenteContrato.taxaPedido) | currency:'BRL':true}}
                                </span>
                                <span class="invalid-feedback" *ngIf="inValorInvalid">
                                    {{ messageValor }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngStyle]="{ display: step == 20 ? 'block' : 'none' }">
                <h5 class="modal-title clean-modal-title">
                    Olá {{ colaboradorToCode.name }} você irá receber
                    <u>{{ valorBeneficio | currency: "BRL":true }}</u>
                </h5>

                <div class="row justify-content-md-center mt-3">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label for="password" class="clean-modal-section-title">Escolha uma senha</label>
                            <input class="input-border-botton form-control" [ngClass]="{'is-invalid':inSenhaInvalid}" type="password" onlyNumber value="" #inSenha maxlength="6" autocomplete="off"/>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label for="confirmpassword" class="clean-modal-section-title">Confirme a senha</label>
                            <input  class="input-border-botton form-control" [ngClass]="{'is-invalid':inSenhaInvalid}" type="password" onlyNumber value="" #inSenhaConfirmacao maxlength="6" autocomplete="off"/>
                        </div>
                        <span class="invalid-feedback" *ngIf="inSenhaInvalid">
                            {{ messageSenha }}
                        </span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="step == 30">
                <ng-container *ngIf="messageStepOk">
                    <h3 class="modal-title clean-modal-title" >Parabéns {{ colaboradorToCode.name }} você acabou de receber {{ valorBeneficio | currency: "BRL":true }}</h3>
                </ng-container>
                <ng-container *ngIf="!messageStepOk">
                    <p class="text-center">
                        {{ messageStep }}
                    </p>
                </ng-container>
            </ng-container>
        </div>
        <div class="col-12 my-2 clean-modal-footer">
            <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')" *ngIf="step != 30">
                Cancelar
            </button>
            <button class="custom-filter-button button-color-just" type="button" (click)="NextStep(inQRCode.value, inValor.value)" *ngIf="step == 10">
                Avançar
            </button>
            <button class="custom-filter-button button-color-just" type="button" (click)="
                    Cadastrar(
                        inQRCode.value,
                        inSenha.value,
                        inSenhaConfirmacao.value,
                        inValor.value,
                        cedenteContrato.taxaPedido,
                        cedenteContrato.ehPorcentagem
                    )
                " *ngIf="step == 20">
                Confirmar
            </button>
            <button class="custom-filter-button button-color-just" type="button" (click)="modal.dismiss('Close click')" *ngIf="step == 30">
                Ok
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="!hasBeneficios">
        <div class="col-12 modal-header clean-modal-header"></div>
        <div class="clean-modal-content">
            <p class="text-center" *ngIf='!hasBeneficios && !hasProdutos'>
                Este favorecido não possui nenhum incentivo aderido ainda!
            </p>
            <p class="text-center" *ngIf='!hasBeneficios && hasProdutos'>
                O favorecido não tem nenhum incentivo concedido!
            </p>
            <p class="text-center" *ngIf="messageStatus">
               {{ messageStatus }}
            </p>
        </div>
        <div class="clean-modal-footer">
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="modal.dismiss('Close click')">
                    Ok
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<!--Modal do Desativar-->
<ng-template #desativarmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">Desativar Favorecido</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p class="text-center">
                Tem certeza que deseja desativar o favorecido: <br><b> {{ collaboratorToDisable.name }}</b>?
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content px-5">
        <b>Justificativa: </b> (obrigatória)
        <textarea rows="5" class="w-100" #inObservacao></textarea>
        <span class="message-error" *ngIf='!justificativaValid'>Digite a justificativa</span>
    </div>

    <div class="col-12 modal-footer clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" (click)="disable(collaboratorToDisable,inObservacao.value);">
            Desativar
        </button>
    </div>
</ng-template>

<!--Modal do Ativar-->
<ng-template #ativarmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">Ativar Favorecido</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p class="text-center">
                Tem certeza que deseja ativar o favorecido: <br><b> {{ collaboratorToEnable.name }}</b>?
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content px-5">
        <b>Justificativa: </b> (obrigatória)
        <textarea rows="5" class="w-100" #inObservacao></textarea>
        <span class="message-error" *ngIf='!justificativaValid'>Digite a justificativa</span>
    </div>

    <div class="col-12 modal-footer clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" (click)="enable(collaboratorToEnable,inObservacao.value)">
            Ativar
        </button>
    </div>
</ng-template>

<!--Modal do Deletar Vários-->
<ng-template #deleteallmodal let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Tem certeza que deseja excluir {{ deleteCount }} favorecido(s) ?
                </p>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    Cancelar
                </button>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" [disabled]="deleteCount < 1" (click)="deleteAllSelected(); modal.dismiss('Close click')">
                    Excluir
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal de Aviso de aceite termo-->
<ng-template #novobeneficio let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Para cadastrar favorecidos, você deve ter ao menos um incentivo ativo.
                </p>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button-text" type="button" (click)="
                        navigateToNovoBeneficio();
                        modal.dismiss('Closeclick')">
                    Clique aqui para ser redirecionado a tela de novo incentivo
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal de Aviso-->
<ng-template #novoColaborador let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Você está cadastrando um favorecido auto-declarado, clique em continuar.
                </p>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    Cancelar
                </button>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="RedirectToCreate(); modal.dismiss('Close click')">
                    Continuar
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #novoColaboradorLote let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Você está cadastrando um favorecido auto-declarado, clique em continuar.
                </p>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    Cancelar
                </button>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="RedirectToCreateLote(); modal.dismiss('Close click')">
                    Continuar
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Modal Carregar Cartão -->
<ng-template #modalCarregarCartao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Carregar cartão
            </h5>
            <p class="clean-modal-subtitle" *ngIf="hasProdutos && hasBeneficios && selectedProduct == null">
                Selecione o incentivo que deseja para carregar o cartão
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <!--<ng-container *ngIf="hasProdutos && selectedProduct == null">
                <div class="row col-md-12">
                    <div class="card col-md-4 clean-card-container" *ngFor="let cedenteContrato of cedenteContratoList">
                        <div class="card-body clean-card-content" (click)="setProdutoRecarga(cedenteContrato.produtoElegibilidade.produto.produtoGuid)">
                            <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                <img [src]="'./assets/icons/produtos/icon-produtos/'+ cedenteContrato.produtoElegibilidade.produto.produtoGuid +'.svg'" class="card-img-top clickable" alt="{{cedenteContrato.produtoElegibilidade.produto.descricao}}"
                                />
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                <p class="card-title ">
                                    {{cedenteContrato.produtoElegibilidade.produto.descricao}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container> --->

            <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct == null">
                    <div *ngFor="let categoria of beneficioGrupo">
                        <ng-container *ngIf="categoria.beneficios.length > 0">
                            <h5 class="modal-title clean-modal-title text-left my-2" style="font-size: 20px;">{{categoria.produtoCategoriaLabelCedente}}</h5>
                            <div class="row col-md-12">
                            <div class="col-md-3 px-0" *ngFor="let item of categoria.beneficios; let i= index">
                                <div (click)="setProdutoCarga(item)">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                        <div class="card-img-top clickable">
                                            <app-svg-card [color]="item.produtoColor" [icon]="item.produtoIcon" [name]="item.produtoNome"></app-svg-card>
                                        </div>
                                        <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ item.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="card-img-top clickable" alt="{{item.produtoNome}}"/-->
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                        <p class="card-title ">
                                            {{item.produtoNome}}</p>
                                    </div>
                                    <!--<p class="form-check-label font-weight-normal">
                                        {{item.produtoNome}}
                                    </p>

                                    <img [src]="'./assets/icons/produtos/icon-produtos/'+
                                        item.produtoGuid +'.svg'" class="img-card mb-5" alt="{{item.produtoNome}}" />

                                    <div class="div-select-create custom-input-container">
                                        <label>Regularidade: {{item.periodo}}</label>
                                    </div>
                                    <div class="custom-input-container">
                                        <span>R$ {{ item.valor}}</span>
                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct == null">
                <div class="row col-md-12">
                    <div class="card col-md-4 clean-card-container" *ngFor="let item of beneficios; let i= index">
                        <div class="card-body clean-card-content" (click)="setProdutoCarga(item)">
                            <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                <div class="card-img-top clickable">
                                    <app-svg-card [color]="item.produtoColor" [icon]="item.produtoIcon" [name]="item.produtoNome"></app-svg-card>
                                </div>
                                <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ item.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="card-img-top clickable" alt="{{item.produtoNome}}"/-->
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                <p class="card-title ">
                                    {{item.produtoNome}}</p>
                            </div>
                            <!--<p class="form-check-label font-weight-normal">
                                {{item.produtoNome}}
                            </p>

                            <img [src]="'./assets/icons/produtos/icon-produtos/'+
                                item.produtoGuid +'.svg'" class="img-card mb-5" alt="{{item.produtoNome}}" />

                            <div class="div-select-create custom-input-container">
                                <label>Regularidade: {{item.periodo}}</label>
                            </div>
                            <div class="custom-input-container">
                                <span>R$ {{ item.valor}}</span>
                            </div>-->
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct != null && !continuarRecarga && loaded">
                <form [formGroup]="valorRecargaForm" *ngIf='!messageStatus && cedenteContrato.ehEditavel'>
                    <div class="row col-md-12 justify-content-md-center">
                        <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && cedenteContrato.ehPorcentagem">
                            A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? valorRecarga * cedenteContrato.taxaPedido / 100 : cedenteContrato.valorPadrao * cedenteContrato.taxaPedido / 100) | currency:'BRL':true}}
                        </span>
                        <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && !cedenteContrato.ehPorcentagem">
                            A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? cedenteContrato.taxaPedido :cedenteContrato.taxaPedido) | currency:'BRL':true}}
                        </span>
                        <div class="form-group w-50">
                            <label for="valor" class="clean-modal-section-title">Insira o valor que deseja carregar no cartão do favorecido</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <!--[textMask]="{mask: MASKS.currency.textMask}"-->

                                <input [readonly]="!cedenteContrato.ehEditavel" [(ngModel)]="valorRecarga" class="input-border-botton form-control" [ngClass]="{'is-invalid':inValorInvalid}" formControlName="valorRecarga" type="number" value="{{ cedenteContrato.valorPadrao }}" min="{{ cedenteContrato.valorPadrao }}" step="{{cedenteContrato.valorIncremento}}" max="{{ cedenteContrato.valorMaximoBeneficio }}" autocomplete="off"/>

                            </div>
                        </div>
                        <span class="text-center invalid-feedback" *ngIf="inValorInvalid">
                            {{messageValor}}
                        </span>
                    <!--<input name="valor-beneficio" id="valor-beneficio" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" [(ngModel)]="valorBeneficio" class="input-value" placeholder="R$ 0,00">-->
                    </div>
                </form>
                <div *ngIf="!messageStatus && !cedenteContrato.ehEditavel" class="row col-md-12 justify-content-md-center">
                    <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && cedenteContrato.ehPorcentagem">
                        A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? valorRecarga * cedenteContrato.taxaPedido / 100 : cedenteContrato.valorPadrao * cedenteContrato.taxaPedido / 100) | currency:'BRL':true}}
                    </span>
                    <span class="clean-modal-section-subtitle mb-1" *ngIf="cedenteContrato.taxaPedido > 0 && !cedenteContrato.ehPorcentagem">
                        A taxa para a recarga com esse incentivo é de {{ (valorRecarga != undefined ? cedenteContrato.taxaPedido :cedenteContrato.taxaPedido) | currency:'BRL':true}}
                    </span>
                    <div class="form-group w-50">
                        <p style="text-align: center; font-size: 20px;">O valor a ser disponibilizado para o favorecido será: <b>{{cedenteContrato.valorPadrao | currency: 'BRL':true }}</b></p>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="hasProdutos && hasBeneficios && selectedProduct != null && continuarRecarga && loaded">
                <div class="row col-md-12 justify-content-md-center">
                    <p class="clean-modal-section-subtitle text-center">
                        Você confirma a recarga de
                        <strong>{{ (valorRecarga != undefined ? valorRecarga :  cedenteContrato.valorPadrao) | currency:'BRL':true}}</strong>
                        de {{ selectedProduct.produtoNome }}
                        <br>
                        para o favorecido <strong>{{ colaboradorToCode.name }}</strong>?
                    </p>
                </div>
            </ng-container>
            <p class="text-center" *ngIf='!hasBeneficios && !hasProdutos'>
                Você não possui nenhum incentivo aderido ainda!
            </p>
            <p class="text-center" *ngIf='!hasBeneficios && hasProdutos'>
                O favorecido não tem nenhum incentivo concedido!
            </p>
            <p class="text-center" *ngIf='messageStatus'>
                {{messageStatus}}
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="continuarRecarga ? continuarRecarga=false : modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="continuarRecarga=true" *ngIf="hasProdutos && selectedProduct != null && !continuarRecarga && !messageStatus">
            Continuar
        </button>
        <button class="custom-modal-button" type="button" (click)="confirmarRecarga(modalPin,cedenteContrato.valorPadrao, cedenteContrato.taxaPedido, cedenteContrato.valorMaximoBeneficio, cedenteContrato.ehPorcentagem)" *ngIf="hasProdutos && selectedProduct != null && continuarRecarga && !messageStatus">
            Confirmar
        </button>
    </div>
</ng-template>

<!-- Modal Ultimos Creditos -->
<ng-template #modalLastCredits let-modal>
<div class="col-12 modal-header clean-modal-header">
    <div class="col-md-12">
        <h5 class="clean-modal-title">Histórico de Créditos</h5>
    </div>
</div>
    <div class="row p-4 d-flex justify-content-end ">
        <div class="col-auto my-auto">
            <div (click)="getExtract(1,colaId)" class="list-select ml-2 my-1">
                <button class="list-select"  type="button">
                    <span>Aplicar</span>
                </button>
            </div>
        </div>
        <div class="col-auto">
              <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="extratoDataInicio" (dateChange)="setPeriod(true,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                    <mat-error>Escolha uma data ou período</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="col-auto">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="endDate" [max]="maxDate" matInput [matDatepicker]="endDate" placeholder="Data Fim" [value]="extratoDataFim" (dateChange)="setPeriod(false,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                    <mat-error>Escolha uma data ou período</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="col-12">
            <div class="table-overflow">
                <div class="table-responsive">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th scope="col">Recarga</th>
                                <th scope="col">Gestor</th>
                                <th scope="col">Favorecido</th>
                                <th scope="col">Data da recarga</th>
                                <th scope="col">Produto</th>
                                <th scope="col">Valor</th><th scope="col">Data de processamento</th>
                                <th scope="col">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of extractList | paginate : { itemsPerPage: limitModal, currentPage: extractPage, id: 'LastCreditsPagination', totalItems: extracttotalItems }">
                                <td>{{ item.purchaseId }}</td>
                                <td>{{ item.managerName }}</td>
                                <td>{{ item.collaboratorName }}</td>
                                <td>{{ item.purchaseDate | date: "dd/MM/yy HH:mm" }}</td>
                                <td>{{ item.productName }}</td>
                                <td>{{ item.orderItemValue | currency: "BRL":true }}</td>
                                <td>{{ item.releaseDate | date: "dd/MM/yy HH:mm" }}</td>
                                <td>{{ item.statusDescription }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="extracttotalItems === 0" class="text-center">
                        <h6>
                            Nenhum crédito carregado.
                        </h6>
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls  id="LastCreditsPagination" (pageChange)="getExtract($event, colaId)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();" ngbAutofocus>
            Aplicar
        </button>
    </div-->
</ng-template>

<!-- Modal Ultimos Creditos -->
<ng-template #modalExtractFavored let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Extrato do Favorecido</h5>
        </div>
    </div>
        <div class="row px-4 d-flex justify-content-end ">
            <div class="col-auto my-auto">
                <div (click)="getExtractFavored(1)" class="list-select ml-2 my-1">
                    <button class="list-select"  type="button">
                        <span>Aplicar</span>
                    </button>
                </div>
            </div>
            <div class="col-auto">
                  <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="extratoDataInicio" (dateChange)="setPeriod(true,$event.value)"/>
                        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                        <mat-datepicker #startDate></mat-datepicker>
                        <mat-error>Escolha uma data ou período</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-auto">
                <div class="custom-filter-input-container">
                    <mat-form-field>
                        <input id="endDate" [max]="maxDate" matInput [matDatepicker]="endDate" placeholder="Data Fim" [value]="extratoDataFim" (dateChange)="setPeriod(false,$event.value)"/>
                        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                        <mat-datepicker #endDate></mat-datepicker>
                        <mat-error>Escolha uma data ou período</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row px-4">
            <div class="col-auto my-auto pr-0">
                <div (click)="exportExtractPdf()" class="list-select ml-2 my-1">
                    <button class="list-select"  type="button">
                        <span>Exportar PDF</span>
                    </button>
                </div>
            </div>
            <div class="col-auto my-auto pr-0">
                <div (click)="exportExtractExcel()" class="list-select ml-2 my-1">
                    <button class="list-select"  type="button">
                        <span>Exportar Excel</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row px-4 d-flex justify-content-end ">
            <div class="col-12">
                <div class="table-overflow">
                    <div class="table-responsive">
                        <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th scope="col">Origem</th>
                                    <th scope="col">Destino</th>
                                    <th scope="col">Descritivo Transação</th>
                                    <th scope="col">Produto</th>
                                    <th scope="col">Data da Transação</th>
                                    <th scope="col">Valor</th>
                                    <th scope="col">Via</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of extractList | paginate : { itemsPerPage: limitModal, currentPage: extractPage, id: 'extractPagination', totalItems: extracttotalItems }">
                                    <td>{{ item.pessoaOrigem }}</td>
                                    <td>{{ item.pessoaDestino }}</td>
                                    <td>{{ item.descritivoTransacao }}</td>
                                    <td>{{ item.descricaoProduto }}</td>
                                    <td>{{ item.dataTransacao | date: "dd/MM/yy HH:mm" }}</td>
                                    <td [ngStyle]="{'color': item.cor}">{{ item.valorLiquido | currency: "BRL":true }}</td>
                                    <td>
                                        <span><img *ngIf="item.tipoTransacao==3" src="./assets/icons/creditCard.png" width="24px"></span>
                                        <span><img *ngIf="item.tipoTransacao==2" src="./assets/icons/pix.svg" width="24px"></span>
                                        <span><img *ngIf="item.tipoTransacao==1" src="./assets/icons/SeuVale.svg" width="24px"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div *ngIf="extractFavoredtotalItems === 0" class="text-center">
                            <h6>
                                Nenhuma transação carregada.
                            </h6>
                        </div>

                        <div class="page-custom mt-2">
                            <pagination-controls id="extractPagination" (pageChange)="getExtractFavored($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--div class="col-12 clean-modal-footer">
            <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();" ngbAutofocus>
                Aplicar
            </button>
        </div-->
    </ng-template>

<!-- Modal Pin -->
<ng-template #modalPin let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Solicitação de Pin</h5>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-end ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Digite o PIN enviado por e-mail para concluir a recarga:
        </p>
        <div class="col-12 mb-4">
            <div class="text-center">
                <input class="clean-filter-input w-25" id="pin" type="number" #pin />
            <span class="message-error" *ngIf="pinMensagemErro">
                {{ pinMensagemErro }}
            </span>
            </div>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="verificarPin(pin.value)">
            Confirmar
        </button>
    </div>
</ng-template>

<!-- Modal Selecao Vinculacao do cartao -->
<ng-template #modalNovoSMS let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Enviar SMS</h5>
            <p class="clean-modal-subtitle">
                Envie um novo SMS para o favorecido
            </p>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-end ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 18px;">
            Um novo SMS será enviado para o {{collaboratorSelected.collaboratorType.toLowerCase()}} <b>{{collaboratorSelected.name}}</b> com o número de telefone: <br> <b>{{collaboratorSelected.phoneNumber | telefone}}</b>.
            <br>
            Caso o telefone esteja incorreto, troque na área de edição do favorecido.
        </p>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="enviarNovoSMS(collaboratorSelected.collaboratorID)">
            Enviar
        </button>
    </div>
</ng-template>

<!-- Modal Selecao Vinculacao do cartao -->
<ng-template #modalTrocarSenhaCartao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Trocar Senha</h5>
            <p class="clean-modal-subtitle">
                Troque a senha do cartão do favorecido
            </p>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-end ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 18px;">
            Você está gerando uma nova senha para o cartão do {{collaboratorSelected.collaboratorType.toLowerCase()}} <b>{{collaboratorSelected.name}}</b>.
            <br>
            Será enviada uma nova senha através de um SMS para o telefone: <b>{{collaboratorSelected.phoneNumber | telefone}}</b>.
        </p>
        <!-- <div class="col-12 custom-filter-input-container">
            <label class="clean-filter-label" for="senhaGestor">Digite sua senha:</label>
            <input class="clean-filter-input" id="senhaGestor" type="password" #managerPassword/>
        </div> -->
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <!-- managerPassword.value -->
        <button class="custom-modal-button" type="button" (click)="trocarSenhaCartao(collaboratorSelected)">
            Gerar Senha
        </button>
    </div>
</ng-template>


<!-- Modal Selecao Vinculacao do cartao portador -->
<ng-template #modalTrocarSenhaCartaoPortador let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Trocar Senha</h5>
            <p class="clean-modal-subtitle">
                Troque a senha do cartão do portador
            </p>
        </div>
    </div>
        <div class="row px-4 d-flex justify-content-end ">
            <p class="col-12 clean-modal-subtitle" style="font-size: 18px;">
                Você está gerando uma nova senha para o cartão de final {{ '**** **** **** ' + collaboratorSelected.cardholderCardLastDigits }}
            </p>
            <div class="col-12 custom-filter-input-container">
                <form [formGroup]="cardPasswordResetFormGroup">
                    <div class="row p-4 d-flex justify-content-center">
                        <div class="col-6 text-center">
                            <mat-form-field >
                                <mat-label>Nova senha do cartão</mat-label>
                                <input matInput formControlName="newCardPin" type="password" maxlength="4" onlyNumber>
                            </mat-form-field>
                            <mat-error *ngIf="(cardPasswordResetFormGroup.get('newCardPin').invalid && (cardPasswordResetFormGroup.get('newCardPin').dirty || cardPasswordResetFormGroup.get('newCardPin').touched)) && cardPasswordResetFormGroup.get('newCardPin').errors.required">
                                A nova senha do cartão é obrigatória!
                            </mat-error>
                            <mat-error *ngIf="(cardPasswordResetFormGroup.get('newCardPin').invalid && (cardPasswordResetFormGroup.get('newCardPin').dirty || cardPasswordResetFormGroup.get('newCardPin').touched)) && (cardPasswordResetFormGroup.get('newCardPin').errors.minlength && cardPasswordResetFormGroup.get('newCardPin').errors.maxlength)">
                                A nova senha deve conter 4 dígitos
                            </mat-error>
                        </div>
                        <div class="col-6 text-center">
                            <mat-form-field>
                                <mat-label>Confirmação da senha</mat-label>
                                <input matInput formControlName="confirmNewCardPin" type="password" maxlength="4" onlyNumber>
                            </mat-form-field>
                            <mat-error *ngIf="(cardPasswordResetFormGroup.get('confirmNewCardPin').invalid && (cardPasswordResetFormGroup.get('confirmNewCardPin').dirty || cardPasswordResetFormGroup.get('confirmNewCardPin').touched)) && cardPasswordResetFormGroup.get('confirmNewCardPin').errors.required">
                                A senha de confirmação é obrigatória
                            </mat-error>
                            <mat-error *ngIf="(cardPasswordResetFormGroup.get('confirmNewCardPin').invalid && (cardPasswordResetFormGroup.get('confirmNewCardPin').dirty || cardPasswordResetFormGroup.get('confirmNewCardPin').touched)) && cardPasswordResetFormGroup.get('confirmNewCardPin').errors.mustMatch">
                                As senhas devem coincidir
                            </mat-error>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    
        <div class="col-12 clean-modal-footer">
            <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')" ngbAutofocus>
                Cancelar
            </button>
            <!-- managerPassword.value -->
            <button class="custom-modal-button" type="button" (click)="trocarSenhaCartaoPortador(collaboratorSelected)">
                Gerar Senha
            </button>
        </div>
</ng-template>

<!-- Modal Selecao Vinculacao do cartao -->
<ng-template #modalVerCartao let-modal>
    <div class="col-12 pb-0 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Visualizar Cartão</h5>
            <p class="clean-modal-subtitle">
                Você está visualizando o cartao do {{collaboratorSelected.collaboratorType.toLowerCase()}} <b>{{collaboratorSelected.name}}</b>
            </p>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-center ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 18px;" *ngIf="collaboratorSelected?.collaboratorCardLastDigits != null" >
            Número do cartão: {{ '**** **** **** ' + collaboratorSelected.collaboratorCardLastDigits}}
        <br>
        </p>
        <div class="col-10 custom-filter-input-container" *ngIf="!collaboratorSelected.collaboratorCardDefinitiveBlock && !collaboratorSelected.collaboratorCardTemporaryBlock">
            <p class="clean-modal-subtitle">
                <b>Deseja bloquear este cartão?</b>
            </p>
            <div class="row justify-content-center">
                <div  class="col-6">
                    <div  class="component-box container-fluid mb-2 mt-2 mr-4 clickable border-button" (click)="ShowModalConfimacao(modalConfirmacao, true)">
                        <!-- <div  class="component-box container-fluid mb-2 mt-2 mr-4 clickable border-button" (click)="bloquearCartao({ temporary: true, confirm: false })"> -->
                        
                        <div class="container-fluid row mx-0 p-3">
                            <div class="col-md-12 align-items-center pt-2 text-center">
                                <div class="col-md-12">
                                    <h5 class="m-0">Bloqueio Temporário</h5>
                                </div>
                            </div>
                            <div class="col align-self-center pb-2">
                                <div class="text-center">
                                    <p>
                                        Após esse bloqueio você ainda poderá desbloquear esse cartão e utilizá-lo novamente.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <hr> -->
                <div class="col-6">
                    <div class="component-box container-fluid mb-0 mt-2 mr-4 clickable border-button"  (click)="ShowModalConfimacao(modalConfirmacao)">
                        <!-- <div class="component-box container-fluid mb-0 mt-2 mr-4 clickable border-button" (click)="bloquearCartao({ confirm: false })"> -->
                        <div class="container-fluid row mx-0 p-3">
                            <div class="col-md-12 align-items-center pt-2 text-center">
                                <div class="col-md-12">
                                    <h5 class="m-0">Bloqueio Definitivo</h5>
                                </div>
                            </div>
                            <div class="col align-self-center pb-2">
                                <div class="text-center">
                                    <p>
                                        Após esse bloqueio não será mais possível utilizar esse cartão. Você deverá vincular um novo cartão para esse favorecido.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 custom-filter-input-container" *ngIf="collaboratorSelected.collaboratorCardTemporaryBlock && !collaboratorSelected.collaboratorCardDefinitiveBlock">
            <p class="clean-modal-subtitle">
                <b>Deseja desbloquear este cartão?</b>
            </p>
            <div  class="component-box container-fluid mb-2 mt-2 mr-4 clickable border-button" (click)="desbloquearCartao()">
                <div class="container-fluid row mx-0 p-3">
                    <div class="col-md-12 align-items-center pt-2 text-center">
                        <div class="col-md-12">
                            <h5 class="m-0">Desbloquear Cartão</h5>
                        </div>
                    </div>
                    <div class="col align-self-center pb-2">
                        <div class="text-center">
                            <p>
                                Desbloqueie o cartão do {{collaboratorSelected.collaboratorType.toLowerCase()}}.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <mat-checkbox class="" color="primary" (change)="showReason($event.checked)">Bloquear o cartão</mat-checkbox>
            <br>
            <mat-form-field  *ngIf="showReasons">
                <mat-label>Motivos</mat-label>
                <mat-select placeholder="Selecione...">
                    <mat-option>Nenhum</mat-option>
                    <mat-option *ngFor="let item of reasons" [value]="item.id" (click)="getReason(item.psBlockCode)">{{item.value}}</mat-option>
                    <mat-option (click)="getReason('otherReason')" value="otherReason">Outro</mat-option>
                </mat-select>
            </mat-form-field>
            <br>
            <mat-form-field *ngIf="showOtherReasonInp && showReasons">
                <mat-label>Outro motivo</mat-label>
                <input matInput type="text" id="otherReason" value="" #otherReason>
            </mat-form-field>

            <button class="custom-modal-button" type="button" (click)="bloquearCartao()">
                Bloquear
            </button> -->
        </div>
        <div class="col-6 custom-filter-input-container" *ngIf="collaboratorSelected.collaboratorCardDefinitiveBlock">
            <div  class="component-box container-fluid mb-2  mt-2 mr-4">
                <div class="container-fluid row mx-0 p-3">
                    <div class="col-md-12 align-items-center pt-2 text-center">
                        <div class="col-md-12">
                            <h5 class="m-0">Cartão Bloqueado</h5>
                        </div>
                    </div>
                    <div class="col align-self-center pb-2">
                        <div class="text-center">
                            <p>
                                Este cartão está bloqueado de forma definitiva.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<!-- Modal Confirmação -->
<ng-template #modalConfirmacao let-modal>
    <div class="col-12 pb-0 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Confirmar Bloqueio do Cartão </h5>
        </div>
    </div>
    <div class="row p-4 d-flex justify-content-center ">
        <div class="col-md-12 align-items-center pt-2 text-center">
            <p class="m-0">
                Confirma o bloqueio do cartão
            </p>
            <p class="m-0" *ngIf="collaboratorSelected?.collaboratorCardLastDigits != null">
                {{ '**** **** **** ' + collaboratorSelected.collaboratorCardLastDigits}}
            </p>                
            <p class="m-0">
                do {{ collaboratorSelected.collaboratorType.toLowerCase() }} {{ collaboratorSelected.name }}?
            </p>
            <!-- <div class="text-center">
                <p>
                    Este cartão está bloqueado de forma definitiva.
                </p>
            </div> -->
        </div>
    </div>

    <div class="col-12 p-2 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modalService.dismissAll()">
            Cancelar
        </button>
        <button class="custom-filter-button mr-2" (click)="bloquearCartao(temp)">
            Confirmar
        </button>
    </div>
</ng-template>

<!--Modal de Aviso Novo Cartao-->
<ng-template #modalAvisoVincularCartao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Vincular Cartão</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text text-center" style="font-size: 18px;">
            Este colaborador já tem um cartão vinculado, ao vincular um novo o antigo será desativado.
            <br>
            Ao vincular um novo cartão o atual será bloqueado, sem possibilidade de desbloqueio.
            <br>
            <b>Deseja Continuar?</b>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="getReason(12);bloquearCartao(false, true); modal.dismiss('Close click')">
            Continuar
        </button>
    </div>
    <!-- <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Este colaborador já tem um cartão vinculado, ao vincular um novo o antigo será desativado.
                    Deseja Continuar?
                </p>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    Cancelar
                </button>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="redirectVincularCartao(); modal.dismiss('Close click')">
                    Continuar
                </button>
            </div>
        </div>
    </div>-->
</ng-template>


<!-- Modal Carregar Cartão -->
<ng-template #showSuspender let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Suspender Favorecido
            </h5>
            <p ngbAutofocus class="clean-modal-subtitle">
                Selecione a data do inicio e fim da suspensão do favorecido
            </p>
        </div>
    </div>
    <div class="row px-5 d-flex">
        <div class="col-6">
              <div class="custom-filter-input-container">
                <mat-form-field class="w-100">
                    <input id="startDateSusp" matInput [matDatepicker]="startDateSusp" placeholder="Data Início" [value]="startDateSuspend" (dateChange)="setPeriodSuspend(true,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="startDateSusp"></mat-datepicker-toggle>
                    <mat-datepicker #startDateSusp></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-6">
            <div class="custom-filter-input-container">
                <mat-form-field class="w-100">
                    <input id="endDateSusp" matInput [matDatepicker]="endDateSusp" placeholder="Data Fim" [value]="endDateSuspend" (dateChange)="setPeriodSuspend(false,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="endDateSusp"></mat-datepicker-toggle>
                    <mat-datepicker #endDateSusp></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    
    <div class="row px-5 pb-3 d-flex">
        <div class="col">
              <div class="custom-filter-input-container">
                <mat-form-field class="w-100">
                    <mat-label>Justificativa <span>(obrigatório)</span></mat-label>
                    <textarea matInput rows="5" [formControl]="justifySuspend"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>

    <span class="text-center message-error" *ngIf='!justificativaValid'>Informações inválidas</span>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="suspend(collaboratorToDisable)">
            Continuar
        </button>
    </div>
</ng-template>
<!-- Linha 2000, não desça mais que isso -->

<!-- Modal Carregar Cartão -->
<ng-template #showConductor let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Resetar senha do Condutor
            </h5>
            <p ngbAutofocus class="clean-modal-subtitle">
            </p>
        </div>
    </div>
    
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p class="text-center">                
                Tem certeza que deseja resetar a senha do aplicativo do condutor?
            </p>
            <p class="text-center">                
                A senha será enviada via sms para o condutor
            </p>
        </div>
    </div>
    
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="resetarSenhaCondutor()">
            Confirmar
        </button>
    </div>
</ng-template>